/* eslint no-unused-vars: 0 */
import $ from "jquery";
import accordion from "./accordion";
import bannerIce from "./banner-ice";
import bannerNotice from "./banner-notice";
import errorFormSubmit from "./error-form-submit";
import filterAjax from "./filter-ajax";
import gutenbergImage from "./gutenberg-image";
import imageGallerySlider from "./image-gallery-slider";
import initCookiePopup from "./cookie-popup";
import initScrollTo from "./scroll-to";
import initShowMoreArticles from "./show-more-article";
import menuAccordion from "./menu-accordion";
import menuDropdown from "./menu-dropdown";
import mobileMenu from "./mobile-menu";
import searchBar from "./search-bar";
import sideMenu from "./sidemenu";
import swiperCarousel from "./swiper-carousel";
import toggleFilter from "./toggle-filter";
import toggleMapFilterView from "./toggle-map-filter-view";

$(document).ready(() => {
    const $cookiePopup = $(".js-cookie-popup");
    if ($cookiePopup.length) {
        $cookiePopup.map((i, v) => initCookiePopup(v));
    }

    const $jsScrollTo = $(".js-scroll-to");
    if ($jsScrollTo.length) {
        $jsScrollTo.map((i, v) => initScrollTo(v));
    }

    const $jsMobileMenu = $(".js-toggle-menu");
    if ($jsMobileMenu.length) {
        $jsMobileMenu.map((i, v) => mobileMenu(v));
    }

    const $jsMenuAccordion = $(".js-menu-accordion");
    if ($jsMenuAccordion.length) {
        $jsMenuAccordion.map((i, v) => menuAccordion(v));
    }

    const $jsAccordion = $(".js-accordion-button");
    if ($jsAccordion.length) {
        $jsAccordion.map((i, v) => accordion(v));
    }

    const $jsBannerNotice = $(".js-notice-button");
    if ($jsBannerNotice.length) {
        $jsBannerNotice.map((i, v) => bannerNotice(v));
    }

    const $gutenberg = $(".js-gutenberg");
    if ($gutenberg.length) {
        $gutenberg.map((i, v) => gutenbergImage(v));
    }

    const $jsBannerIce = $(".js-banner-button");
    if ($jsBannerIce.length) {
        $jsBannerIce.map((i, v) => bannerIce(v));
    }

    const $jsMenuDropdown = $(".js-menu-dropdown");
    if ($jsMenuDropdown.length) {
        $jsMenuDropdown.map((i, v) => menuDropdown(v));
    }

    const $jsSideMenu = $(".js-toggle-sidemenu");
    if ($jsSideMenu.length) {
        $jsSideMenu.map((i, v) => sideMenu(v));
    }

    const $swiperCarousel = $(".js-carousel-container");
    if ($swiperCarousel.length) {
        $swiperCarousel.map((_i, v) => swiperCarousel(v));
    }

    const $imageGallerySlider = $(".js-slider-gallery");
    if ($imageGallerySlider.length) {
        $imageGallerySlider.map((_i, v) => imageGallerySlider(v));
    }

    const $initShowMoreArticles = $(".js-more-articles");
    if ($initShowMoreArticles.length) {
        $initShowMoreArticles.map((_i, v) => initShowMoreArticles(v));
    }

    const $toggleMapFilterView = $(".js-toggle-map-filter-view-button");
    if ($toggleMapFilterView.length) {
        $toggleMapFilterView.map((i, v) => toggleMapFilterView(v));
    }

    const $searchBar = $(".js-search-bar");
    if ($searchBar.length) {
        $searchBar.map((i, v) => searchBar(v));
    }

    const $filterAjax = $(".js-filter-ajax");
    if ($filterAjax.length) {
        $filterAjax.map((i, v) => filterAjax(v));
    }

    const $toggleFilter = $(".js-toggle-filter");
    if ($toggleFilter.length) {
        $toggleFilter.map((_i, v) => toggleFilter(v));
    }

    const $errorFormSubmit = $(".js-error-form");
    if ($errorFormSubmit.length) {
        $errorFormSubmit.map((_i, v) => errorFormSubmit(v));
    }
});
